import React from "react";
import PropTypes from "prop-types";
import { TextField, IconButton, Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export const DeletableInput = ({
    id,
    label,
    required,
    helperText,
    error,
    multiline,
    minRows,
    maxRows,
    fullWidth,
    variant,
    onChange,
    onDelete,
    classes,
    ...props
}) => (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "600px" }}>
        <TextField
            hiddenLabel={label === ""}
            id={id}
            label={label}
            required={required}
            helperText={helperText}
            error={error}
            multiline={multiline}
            minRows={minRows}
            maxRows={maxRows}
            fullWidth={fullWidth}
            variant={variant}
            onChange={onChange}
            classes={classes}
            sx={{
                "& .MuiInputLabel-root": {
                    color: "#BAC1C5 !important",
                },
                flex: 1,
            }}
            {...props}
        />
        <IconButton
            onClick={onDelete}
            aria-label="delete"
            size="small"
            sx={{ marginLeft: 1 }}
        >
            <DeleteIcon />
        </IconButton>
    </Box>
);

export default DeletableInput;

DeletableInput.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    helperText: PropTypes.string,
    error: PropTypes.bool,
    multiline: PropTypes.bool,
    minRows: PropTypes.number,
    maxRows: PropTypes.number,
    fullWidth: PropTypes.bool,
    variant: PropTypes.string,
    onChange: PropTypes.func,
    onDelete: PropTypes.func.isRequired,
    classes: PropTypes.object,
};

DeletableInput.defaultProps = {
    label: "",
    required: false,
    helperText: "",
    error: false,
    multiline: false,
    fullWidth: true,
    variant: "outlined",
    onChange: () => { },
    classes: {},
};
